<!-- 核验进度 -->

<template>
  <div class="press-3">
    <div class="tabTtl">
      <span>音像电子出版物核验进度</span>
      <a :href="filrUrl1" class="downBtn" download><el-button size="mini">下载封面和盖章页</el-button></a>
    </div>
    <div class="tabArea">
      <el-table :data="tabDat" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column label="核验年度" align="center">
          <template slot-scope="scope">
            {{ scope.row | strTrans("year") }}
          </template>
        </el-table-column>
        <el-table-column label="核验项目" align="center">
          <template slot-scope="scope">
            {{ scope.row.type | strTrans("type") }}
          </template>
        </el-table-column>
        <el-table-column prop="organizationName" label="出版单位" align="center"> </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row | strTrans("pgstate") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.taskStatus == 7" @click="goDeep(scope.row)" size="mini">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getPgress } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      tabDat: [],
      filrUrl1: "",
    };
  },
  filters: {
    strTrans: function (dat, code) {
      if (code == "year") {
        return dat.firstYear + "-" + dat.secondYear;
      } else if (code == "type") {
        let transArr = ["音像制品出版单位", "电子出版物出版单位"];
        return transArr[dat - 1];
      } else if (code == "status") {
        let transArr = ["音像制品出版单位", "电子出版物出版单位"];
        return transArr[dat - 1];
      } else if (code == "pgstate") {
        let setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销",
        };

        let regist = {
          1: "未登记",
          2: "已登记",
        };

        if (dat.progress == "登记") {
          return regist[dat.record];
        } else if (dat.progress == "国家新闻出版署") {
          if (dat.pubStatus == 1 || dat.pubStatus == 0) {
            return "已上报";
          } else {
            return setMap[dat.pubStatus];
          }
        } else if (dat.progress == "开始") {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        } else {
          return "已上报";
        }
      }
    },
  },
  methods: {
    tabInit: function () {
      // 获取当前的年份
      let year1 = this.$store.getters.userInfo.year1;
      getPgress({
        year1: year1,
        type: 1,
        no: 1,
        size: 15,
      }).then((response) => {
        this.tabDat = response.examineProgressList;
      });
    },
    goDeep: function (dat) {
      this.$router.push({
        path: "deep_see",
        query: {
          pressType: dat.type,
        },
      });
    },
  },

  created: function () {
    this.tabInit();
    // this.filrUrl1 = process.env.BASE_API + '/File/File/downloadDrmb?code=0011&token=' + encodeURIComponent(this.$store.getters.token);
    this.filrUrl1 = process.env.URL_FILE + "/drmb/001.xlsx"; // 封面和盖章页
  },
};
</script>

<style lang="scss">
.press-3 {
  padding: 9px 12px;

  .tabTtl {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0px 20px;
    color: #666666;
    font-weight: bold;
  }

  .tabArea {
    margin-top: 10px;
  }

  .downBtn {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// examProgress.vue?02dafccb